import BuyerOrSallerBlock from './buyer-or-saler-block';
export default BuyerOrSallerBlock;